import { useContext } from 'react';

import OfflineDataContext from './OfflineDataContext';

const useOfflineData = () => useContext(OfflineDataContext);

export default useOfflineData;
